<input
  class="keyword-search input-height focus-link"
  type="search"
  dataTestid="keyword-filter-input"
  placeholder="{{ keywordPlaceholder }}"
  [attr.aria-label]="keywordPlaceholder"
  [(ngModel)]="keyword"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (input)="keywordChanged()"
  [ngStyle]="keywordFilterBackgroundImageStyle()" />
